import React, { useState } from 'react';
import { TextField, Button, Box, Typography, Alert } from '@mui/material';
import { useAuth0 } from '@auth0/auth0-react';
import { API_URL } from '../config';

const OrganizationNameForm = ({ currentOrganizationName, onSuccess, customerId, userEmail }) => {
  const [organizationName, setOrganizationName] = useState(currentOrganizationName || '');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const { getAccessTokenSilently } = useAuth0();
  
  const isAddingNew = !currentOrganizationName;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError(null);

    try {
      const token = await getAccessTokenSilently();
      
      // Use the user's email if customerId is not provided
      const payload = {
        organizationName: organizationName
      };
      
      if (customerId) {
        payload.customerId = customerId;
      } else if (userEmail) {
        payload.email = userEmail;
      } else {
        throw new Error('No customer ID or email available');
      }
      
      console.log('Updating organization name with payload:', payload);
      
      const response = await fetch(`${API_URL}/api/update-organization-name`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail || 'Failed to update organization name');
      }

      onSuccess(organizationName);
    } catch (err) {
      console.error('Error updating organization name:', err);
      setError(err.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit}>
      {isAddingNew && (
        <Alert severity="info" sx={{ mb: 2 }}>
          Adding an organization name is required for broadcasting.
        </Alert>
      )}
      <TextField
        fullWidth
        label="Organization Name"
        value={organizationName}
        onChange={(e) => setOrganizationName(e.target.value)}
        required
        margin="normal"
        placeholder="Enter your organization name"
        helperText="This name will be visible to others when you broadcast"
      />
      {error && (
        <Typography color="error" variant="body2" sx={{ mt: 1 }}>
          {error}
        </Typography>
      )}
      <Button
        type="submit"
        variant="contained"
        disabled={isSubmitting}
        color="primary"
        sx={{ mt: 2 }}
      >
        {isSubmitting ? 'Saving...' : isAddingNew ? 'Add Organization Name' : 'Update Organization Name'}
      </Button>
    </Box>
  );
};

export default OrganizationNameForm;